export enum DeviceStatus {
  Active = 'active',
  Inactive = 'inactive',
}
